import React from 'react';
import { useRecoilValue } from 'recoil';
import { OfferContentDisclaimers } from '../../../special-offer/store';
import styles from './index.module.scss';

/**
 * The offer's legal disclaimers, at the foot of the page.
 *
 * Below the enquiry section rather than immediately under the copy, which is where the redesign puts them.
 * The text is authored per offer and rendered as written.
 */
export const OfferDisclaimers: React.FC = () => {
  const disclaimers = useRecoilValue(OfferContentDisclaimers);

  if (disclaimers.length === 0) return null;

  return (
    <div className={styles.disclaimers} data-testid="offer-disclaimers">
      {disclaimers.map((content, index) =>
        content.contentType === 'DISCLAIMER-CONTENT' ? (
          <div
            key={`DISCLAIMER-${index}`}
            dangerouslySetInnerHTML={{ __html: content.content }}
          />
        ) : null
      )}
    </div>
  );
};
